import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { YourApplianceTranslationDictionary } from './your-appliance-dictionary.interface';

export const translation: TranslationDictionaryMapping<YourApplianceTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      YOUR_APPLIANCE_TITLE: 'Your appliance',
    },
    [LocaleId.English_Ireland]: {
      YOUR_APPLIANCE_TITLE: 'Your appliance',
    },
    [LocaleId.English_US]: {
      YOUR_APPLIANCE_TITLE: 'Your appliance',
    },
  };
